var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLunch = function SvgLunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lunch_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M56.75 33.5v1.25h-29.5V33.5c0-2.776 1.3-4.917 3.944-6.44 2.662-1.534 6.257-2.311 10.806-2.31 4.55 0 8.146.778 10.807 2.311 2.644 1.523 3.944 3.664 3.943 6.439Zm-26.757-1.592-.136.342h24.286l-.136-.342c-.61-1.54-2.014-2.691-4.14-3.48-2.124-.788-4.75-1.178-7.867-1.178-3.119 0-5.745.39-7.869 1.178-2.125.789-3.529 1.94-4.138 3.48ZM27.25 48.5v-4.25h29.5v4.25a2.64 2.64 0 0 1-.809 1.943 2.63 2.63 0 0 1-1.94.807H30a2.64 2.64 0 0 1-1.943-.809 2.63 2.63 0 0 1-.807-1.94Zm2.5 0v.25h24.5v-2h-24.5v1.75Zm27-7.003c-1.244-.029-2.008-.276-2.381-.67-.536-.563-1.297-.827-2.244-.827s-1.738.265-2.343.815c-.478.434-1.37.685-2.757.685s-2.264-.252-2.715-.681C43.728 40.265 42.948 40 42 40s-1.728.265-2.31.819c-.45.43-1.327.681-2.715.681-1.39 0-2.249-.252-2.673-.677-.559-.559-1.33-.823-2.277-.823s-1.728.265-2.31.819c-.423.403-1.22.65-2.465.678v-2.503c.836-.044 1.53-.308 2.06-.813.45-.43 1.327-.681 2.715-.681 1.39 0 2.249.252 2.673.677.559.559 1.33.823 2.277.823s1.728-.265 2.31-.819c.45-.43 1.327-.681 2.715-.681s2.264.252 2.715.681c.582.554 1.362.819 2.31.819.947 0 1.718-.264 2.277-.823.424-.425 1.283-.677 2.673-.677 1.384 0 2.294.25 2.798.689a3.25 3.25 0 0 0 1.977.803z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lunch_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4483_45569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4483_45569",
    result: "shape"
  })))));
};
export default SvgLunch;